if (!customElements.get('catterpod-portrait-video')) {
  customElements.define('catterpod-portrait-video', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.video = this.querySelector('video');
      this.video.muted = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.visible = false;
      this.video.addEventListener('pause', () => {
        if (this.visible && !document.hidden) this.userPaused = true;
      });
      this.video.addEventListener('play', () => { this.userPaused = false; });
      this.update = () => {
        if (this.visible && !document.hidden && !this.motion.matches && !this.userPaused) {
          this.video.play().catch(() => { /* Native controls remain available. */ });
        } else if (!this.visible || document.hidden || this.motion.matches) {
          this.video.pause();
        }
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.update);
      this.motion.addEventListener('change', this.update);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.update);
      this.motion?.removeEventListener('change', this.update);
      this.video?.pause();
      this.observer = null;
    }
  });
}
